// extracted by mini-css-extract-plugin
export default {"htmlDescription":"SafeHtml_htmlDescription__+khUm"};